
import { createSelector } from 'reselect'

const innerStateSelector = state => state.purchase;

const membershipsPricingsSelector = createSelector(
   innerStateSelector,
   state => state.membershipsPricings
);
const isFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isFetching
);
const activePurchaseSelector = createSelector(
   innerStateSelector,
   state => state.activePurchase
);
const candidatePaymentOptionsSelector = createSelector(
   innerStateSelector,
   state => state.candidatePaymentOptions
);
const isFetchingJoinSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingJoin
);
const paymentSelector = createSelector(
   innerStateSelector,
   state => state.payment
);
const isFetchingDeclinedSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingDeclined
);
const paymentDeclinedInfoSelector = createSelector(
   innerStateSelector,
   state => state.paymentDeclinedInfo
);
const paymentErrorSelector = createSelector(
   innerStateSelector,
   state => state.paymentError
);
const fetchPaymentUsingWalletSelector = createSelector(
   innerStateSelector,
   state => state.fetchPaymentUsingWallet
);
const contentAvilableMembershipSelector = createSelector(
   innerStateSelector,
   state => state.contentAvilableMembership
);

const isFetchingValidatePromoCodeSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingValidatePromoCode
)

const promoCodeErrorSelector = createSelector(
   innerStateSelector,
   state => state.promoCodeError
)

const isCodeAppliedSelector = createSelector(
   innerStateSelector,
   state => state.isCodeApplied
)

const isFetchingPricingsByCodeSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingPricingsByCode
)

const isAppliedByLinkSelector = createSelector(
   innerStateSelector,
   state => state.isAppliedByLink
)

const encodedPromoCodeSelector = createSelector(
   innerStateSelector,
   state => state.encodedPromoCode
)
const freeTrailModalSelector = createSelector(
   innerStateSelector,
   state => state.freeTrailModal
)
const membershipInfoSelector = createSelector(
   innerStateSelector,
   state => state.membershipInfo
)
const isFetchingPricingsByFilterSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingMembershipsPricingsByFilter
)

const boomfiModalSelector = createSelector(
   innerStateSelector,
   state => state.boomfiModal
)

const isFetchingUpgradeSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingUpgrade
)

export {
   membershipsPricingsSelector,
   isFetchingSelector,
   activePurchaseSelector,
   candidatePaymentOptionsSelector,
   isFetchingJoinSelector,
   paymentSelector,

   isFetchingDeclinedSelector,
   paymentDeclinedInfoSelector,
   paymentErrorSelector,
   fetchPaymentUsingWalletSelector,
   contentAvilableMembershipSelector,

   isFetchingValidatePromoCodeSelector,
   promoCodeErrorSelector,
   isCodeAppliedSelector,
   isFetchingPricingsByCodeSelector,
   isAppliedByLinkSelector,
   encodedPromoCodeSelector,
   freeTrailModalSelector,

   membershipInfoSelector,
   isFetchingPricingsByFilterSelector,
   boomfiModalSelector,
   isFetchingUpgradeSelector,
}
